import healo from "./brands/healo/settings";
import epassi from "./brands/epassi/settings";
import hmc from "./brands/hmc/settings";
import wellnet from "./brands/wellnet/settings";
import actiway from "./brands/actiway/settings";
import dif from "./brands/dif/settings";
import tennis from "./brands/tennis/settings";
import football from "./brands/football/settings";
import as from "./brands/as/settings";

// 1. Implement computing text color based on background
// 2. Future: implement creating brands on backend
// 3. Implement languages inheritance

const brands = {
  healo,
  hmc,
  epassi,
  wellnet,
  dif,
  actiway,
  tennis,
  football,
  as
};

export default {
  brands
};



// WEBPACK FOOTER //
// ./src/modules/brand/brands.js